module.exports = validateFunder

function validateFunder (funder) {
  if (!funder._id) throw new Error('Property \'_id\' is required')
  if (!funder.name) throw new Error('Property \'name\' is required')
  if (!funder.programs) throw new Error('Property \'programs\' is required')
}
